export default {
      id: "mail-usage",
      viewBox: "0 0 37 28",
      url: __webpack_public_path__ + "../../sprite.svg#mail-usage",
      toString: function () {
        return this.url;
      }
    }